import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import './ResidentList.css';

const residents = [
  {
    id: 1,
    name: 'Dr Shani Erez',
    image: '/assets/shani.jpg',
    section: 'Pediatrics',
    lastReviewed: '3 months',
    hasAlert: true
  },
  {
    id: 2,
    name: 'Dr Hillel Sztern',
    image: '/assets/hillel.jpg',
    section: 'Internal Medicine',
    lastReviewed: '5 days',
    hasAlert: false
  },
  {
    id: 3,
    name: 'Dr Maayan',
    image: '/assets/maayan.jpg',
    section: 'Internal Medicine',
    lastReviewed: '2 weeks',
    hasAlert: true
  },
  {
    id: 4,
    name: 'Dr Leehi Pridan',
    image: '/assets/leehi.jpg',
    section: 'Internal Medicine',
    lastReviewed: '3 days',
    hasAlert: false
  },
  {
    id: 5,
    name: 'Dr. Sivan Kijner',
    image: '/assets/sivan.jpg',
    section: 'Pediatrics',
    lastReviewed: '6 weeks',
    hasAlert: true
  },
  {
    id: 6,
    name: 'Dr Noa Shohat',
    image: '/assets/noa.jpg',
    section: 'Internal Medicine',
    lastReviewed: '2 days',
    hasAlert: false
  }
];

const ResidentList: React.FC = () => {
  const [selectedResident, setSelectedResident] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleResidentClick = (residentId: number) => {
    setSelectedResident(residentId);
    navigate(`/resident/${residentId}`);
  };

  return (
    <div className="landing-page">
      <Sidebar />
      
      <div className="main-content residents-page">
        <h1 className="page-title">Resident Dashboard</h1>
        <div className="residents-grid-centered">
          {residents.map((resident) => (
            <div
              key={resident.id}
              className={`resident-card ${selectedResident === resident.id ? 'selected' : ''}`}
              onClick={() => handleResidentClick(resident.id)}
            >
              <div className="resident-image-container">
                <img src={resident.image} alt={resident.name} className="resident-image" />
                {resident.hasAlert && <span className="alert-dot" title="Needs attention"></span>}
              </div>
              <div className="resident-info">
                <h3>{resident.name}</h3>
                <p>{resident.section}</p>
                <span className="last-reviewed">Last reviewed: {resident.lastReviewed} ago</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResidentList;
